import React from 'react';
import { Card, CardContent, Typography, CardActions, Button, Grid } from '@mui/material';
import { format } from 'date-fns'

const TrainingCard = ({ training, handleEdit, handleDelete }) => {
    return (
        <Card sx={{ minWidth: 200 }}>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item md={12}>
                        <Typography variant="h6" component="div" >
                            {training.type}
                        </Typography>
                    </Grid>
                    <Grid item md={12}>
                        <Typography variant="body2" color="textSecondary" >
                            {format(new Date(training.date), 'MMM dd, yyyy hh:mm a')}
                        </Typography>
                    </Grid>
                    <Grid item md={12}>
                        <Typography variant="body2" color="textSecondary" >
                            {training.description}
                        </Typography>
                    </Grid>
                </Grid>

            </CardContent>
            <CardActions>
                <Button size="small" onClick={() => handleEdit(training.id)}>Editar</Button>
                <Button size="small" color='error' onClick={() => handleDelete(training.id)}>Eliminar</Button>
            </CardActions>
        </Card>
    );
};

export default TrainingCard;